import type {PermissaoAplicacao} from "@models/seguranca/permissaoApp.ts";
import {IconButton} from "@mui/material";
import React, {PropsWithChildren, useMemo} from "react";
import {useAuth} from "@contexts/hooks/UseAuth.tsx";

export interface PermissionableIconProps extends React.ComponentProps<typeof IconButton> {
    permissao?: PermissaoAplicacao[],
}

export function PermissionableIcon(props: PropsWithChildren<PermissionableIconProps>) {
    const {hasAccess, permissoes} = useAuth();

    const denied = useMemo(() => {
        if (props.permissao) {
            return !hasAccess(props.permissao)
        }
        return false;
    }, [permissoes, hasAccess, props.permissao]);

    return <IconButton disabled={denied || props.disabled} {...props}>
        {props.children}
    </IconButton>

}